// Header cart "item added" animation (icon markup: sections/header_new.liquid, [data-lb-cart]).
//
// When something is added to the cart, a small box arcs in from the upper left, tumbling,
// the cart tips back to catch it, the box drops into the basket and the cart rocks to a
// stop, while the count badge pops in with the new number.
//
// Triggered by the "added.ajaxProduct" event, which both the product page's Add to cart
// and the product-card bag button fire, or by calling window.lbCartAdded() directly.
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var running = false;

  function cartEl() {
    // the visible cart icon (there is one header, shown on both desktop and phones)
    var all = document.querySelectorAll('[data-lb-cart]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) return all[i];
    }
    return all[0] || null;
  }

  function setCount(cart, count) {
    var badge = cart.querySelector('.lb-hcart__count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('is-empty', count === 0);
    badge.setAttribute('aria-label', count + ' items in cart');
    // keep any other copies of the count (e.g. the theme's own) in step
    document.querySelectorAll('.h_icon_la .tcount, .jsccount').forEach(function (el) {
      if (el !== badge) el.textContent = count;
    });
  }

  function makeBox(cart) {
    var box = document.createElement('span');
    box.className = 'lb-hcart__box';
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML =
      '<svg viewBox="0 0 12 12" width="11" height="11"><rect x="1.2" y="1.2" width="9.6" height="9.6" rx="1.4" ' +
      'fill="none" stroke="currentColor" stroke-width="1.8"/></svg>';
    cart.appendChild(box);
    return box;
  }

  function animate(cart, count) {
    var body = cart.querySelector('.lb-hcart__body');
    var badge = cart.querySelector('.lb-hcart__count');

    if (reduceMotion || !body || !badge || !body.animate) {
      setCount(cart, count);
      return Promise.resolve();
    }

    running = true;
    var box = makeBox(cart);
    var easeOut = 'cubic-bezier(0.22, 0.8, 0.3, 1)';
    var bounce = 'cubic-bezier(0.34, 1.56, 0.64, 1)';

    // 1. the box arcs in from the upper left, tumbling, then drops into the basket
    var fall = box.animate([
      {transform: 'translate(-34px, -30px) rotate(-55deg) scale(0.9)', opacity: 0, offset: 0},
      {transform: 'translate(-20px, -26px) rotate(-30deg) scale(1)', opacity: 1, offset: 0.2},
      {transform: 'translate(-4px, -20px) rotate(0deg)', opacity: 1, offset: 0.48},
      {transform: 'translate(0px, -16px) rotate(18deg)', opacity: 1, offset: 0.62},
      {transform: 'translate(1px, -4px) rotate(40deg) scale(0.85)', opacity: 1, offset: 0.82},
      {transform: 'translate(1px, 1px) rotate(45deg) scale(0.7)', opacity: 0, offset: 1}
    ], {duration: 900, easing: 'linear', fill: 'forwards'});

    // 2. the cart tips back to catch it, then rocks and settles
    // (easing per step, not on the whole animation, so the tip lines up with the box arriving)
    body.animate([
      {transform: 'rotate(0deg)', offset: 0},
      {transform: 'rotate(0deg)', offset: 0.36, easing: 'ease-in-out'},
      {transform: 'rotate(-11deg)', offset: 0.5},
      {transform: 'rotate(-11deg)', offset: 0.6, easing: 'ease-in-out'},
      {transform: 'rotate(7deg)', offset: 0.74, easing: 'ease-in-out'},
      {transform: 'rotate(-3deg)', offset: 0.87, easing: easeOut},
      {transform: 'rotate(0deg)', offset: 1}
    ], {duration: 1100, easing: 'linear'});

    // 3. the badge pops in as the box arrives, with the new number
    setTimeout(function () {
      setCount(cart, count);
      badge.animate([
        {transform: 'scale(0.2)', opacity: 0.4},
        {transform: 'scale(1.35)', opacity: 1, offset: 0.55},
        {transform: 'scale(1)', opacity: 1}
      ], {duration: 520, easing: bounce});
    }, 380);

    // Clean up when the box lands. The timer is a safety net: in a background tab the
    // "finished" signal can be delayed, and the next add should still animate.
    var done = false;
    function cleanUp() {
      if (done) return;
      done = true;
      box.remove();
      running = false;
    }
    setTimeout(cleanUp, 1400);
    fall.finished.then(cleanUp, cleanUp);
    return Promise.resolve();
  }

  // Fetch the real count and animate to it.
  function cartAdded() {
    var cart = cartEl();
    return fetch('/cart.js', {headers: {Accept: 'application/json'}})
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!cart) return;
        if (running) {
          setCount(cart, data.item_count); // a second add while still animating: just update
          return;
        }
        return animate(cart, data.item_count);
      })
      .catch(function () { /* leave the icon as it is */ });
  }

  window.lbCartAdded = cartAdded;

  function listen() {
    if (!window.jQuery) return setTimeout(listen, 100);
    window.jQuery('body').on('added.ajaxProduct', cartAdded);
  }
  listen();
})();
